import React from "react";

export const Services = (props) => {
  return (
    <div id="services" className="text-center">
      <div style={{ margin: 25 }}>
        <div className="section-title">
          <h2>Nuestras Plataformas</h2>
          <p></p>
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {props.data
            ? props.data.map((d, i) => (
                <div
                  key={`${d.name}-${i}`}
                  className="col-md-2"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    padding: "20px",
                    margin: "15px",
                    transition: "transform 0.2s",
                    minWidth: "400px",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.05)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                >
                  <img
                    src={d.icon}
                    alt={d.name}
                    style={{
                      width: "100px",
                      height: "100px",
                      alignSelf: "flex-start",
                    }}
                  />
                  <div className="service-desc" style={{ flexGrow: 1 }}>
                    <h3 style={{ textAlign: "start" }}>{d.name}</h3>
                    <p style={{ textAlign: "start" }}>{d.text}</p>
                  </div>
                  <p style={{ textAlign: "start" }}>{d.h2}</p>

                  {/* Social Icons */}
                  <div
                    style={{
                      marginTop: "auto",
                      alignSelf: "flex-start",
                      display: "flex",
                      gap: "10px",
                      cursor: "pointer",
                    }}
                  >
                    {d.websiteUrl && (
                      <a
                        href={d.websiteUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: "20px", color: "#6c63ff" }}
                      >
                        <i className="fas fa-globe"></i>
                      </a>
                    )}
                    {d.igUrl && (
                      <a
                        href={d.igUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: "20px", color: "#E1306C" }}
                      >
                        <i className="fab fa-instagram"></i>
                      </a>
                    )}
                    {d.youtubeUrl && (
                      <a
                        href={d.youtubeUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: "20px", color: "#FF0000" }}
                      >
                        <i className="fab fa-youtube"></i>
                      </a>
                    )}
                    {d.tiktokUrl && (
                      <a
                        href={d.tiktokUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: "20px", color: "#000000" }}
                      >
                        <i className="fab fa-tiktok"></i>
                      </a>
                    )}
                    {d.spotifyUrl && (
                      <a
                        href={d.spotifyUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: "20px", color: "#000000" }}
                      >
                        <i className="fab fa-spotify"></i>
                      </a>
                    )}
                  </div>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>

      {/* Optional hover effect for icons */}
      <style>
        {`
          a i:hover {
            transform: scale(1.2);
            transition: all 0.3s ease;
            opacity: 0.8;
          }
        `}
      </style>
    </div>
  );
};
